import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { NgSwitcheryModule } from "angular-switchery-ios";

import { AppComponent } from './app.component';
import { environment } from '../environments/environment.prod';
import { RouterModule, Routes } from '@angular/router';
import { ThemesComponent } from './themes/themes.component';
import { ThemeFormComponent } from './themes/theme-form/theme-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ThemeListComponent } from './themes/theme-list/theme-list.component';
import { ItemsComponent } from './items/items.component';
import { ItemListComponent } from './items/item-list/item-list.component';
import { ItemFormComponent } from './items/item-form/item-form.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { EventsComponent } from './events/events.component';
import { EventDetailsComponent } from './events/event-details/event-details.component';
import { ParticipantComponent } from './shared/participant/participant.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from './shared/login/login.component';
import { AuthGuardService } from './services/auth-guard.service';
import { OwnItemsComponent } from './own-items/own-items.component';

const routes: Routes = [
  { path: '', redirectTo: '/events', pathMatch: 'full'},
  { path: 'login', component: LoginComponent },
  { path:  'events', component: EventsComponent, canActivate: [AuthGuardService] },
  { path:  'events/:id', component: EventDetailsComponent, canActivate: [AuthGuardService] },
  { path:  'themes', component: ThemesComponent, canActivate: [AuthGuardService] },
  { path:  'items', component: ItemsComponent, canActivate: [AuthGuardService] },
    { path:  'items/:id', component: ItemsComponent, canActivate: [AuthGuardService] },
    { path:  'own-items', component: OwnItemsComponent, canActivate: [AuthGuardService] }
];

@NgModule({
  declarations: [
    AppComponent,
    ThemesComponent,
    ThemeFormComponent,
    ThemeListComponent,
    ItemsComponent,
    ItemListComponent,
    ItemFormComponent,
    NavbarComponent,
    EventsComponent,
    EventDetailsComponent,
    ParticipantComponent,
    LoginComponent,
    OwnItemsComponent
  ],
    imports: [
        BrowserModule,
        AngularFireModule.initializeApp(environment.firebase),
        AngularFirestoreModule,
        AngularFireAuthModule,
        AngularFireStorageModule,
        RouterModule.forRoot(routes),
        ReactiveFormsModule,
        FormsModule,
        NgbModule,
        NgSwitcheryModule
    ],
  exports: [RouterModule],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
